// extracted by mini-css-extract-plugin
export default {"job-list":"JobListContainer_job-list__lknee"};